import { useContext } from 'react';

import { Announce } from '../Announcer';
import AnnouncerContext from '../AnnouncerContext';

type UseAnnouncer = () => Announce;
export const useAnnouncer: UseAnnouncer = () => useContext(AnnouncerContext).announce;
